import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { GetIconByName } from "../../config/icon";
import { Button, ButtonIcon, GazettePreviewComponent, PDFPreviewer } from "..";
import { FiChevronUp } from "react-icons/fi";

const Index = (props) => {
  const [isExpand, setIsExpand] = useState(props.isExpand || false);

  const onClickExpand = () => {
    setIsExpand((prev) => !prev);
  };

  useEffect(() => {
    if (!isExpand) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [isExpand]);

  return (
    <>
      <div className="gaz-prev-card-wrapper">
        <div className={`gaz-pcw-body-wrapper  w-100`}>
          <div className="gpcw-title">{props.title}</div>

          <div className="gpcw-left-wrapper">
            <div className="gpcw-download" onClick={props.onClickDownload}>
              Download
            </div>
            <div className="gpcw-icon" onClick={() => onClickExpand()}>
              {GetIconByName(isExpand ? "arrow-up" : "arrow-down")}
            </div>
          </div>
        </div>

        {isExpand && (
          <>
            <div className={`gpcw-preview`}>
              {props.attachments?.length > 0 && (
                <>
                  {props.attachments?.map((img, index) => (
                    <GazettePreviewComponent
                      data={{
                        file_url: img?.file_url,
                        size: "lg mt-3",
                      }}
                    />
                  ))}
                </>
              )}
            </div>
            {/* <div className="gpcw-btn">
              <Button
                data={{
                  buttonIcon: true,
                  btnIcon: <FiChevronUp />,
                  buttonType: "icon",
                  buttonSize: "md",
                  style: "rvow__next",
                }}
                onClick={onClickExpand}
              />
            </div> */}
          </>
        )}
      </div>
    </>
  );
};
export default Index;
